import React from 'react';

import moment from "moment";
import { t } from "../../../../helpers/translator";
import CasinoNumbers from '../components/casinoNumbers';

export function goldenRaceSelectionColumnConfig() {
    return [
        {
            name: () => t('Match Name'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.event.playlistDescription,
        },
        {
            name: () => t('Market - selection'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.marketFullName,
        },
        {
            name: () => t('Odd'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.oddValue,
        },
        // {
        //     name: () => t('Event result'),
        //     rowClassName: 'multiple-wins-popup-info-row',
        //     row: item => <p className='match_result'>
        //         {this.state.scores && this.state.scores[item.match_id] ? this.state.scores[item.match_id] : "-"}
        //     </p>
        // },
        {
            name: () => t('Start date'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => <div className="match-day">
                <p>{moment(item.event.eventTime).format("DD/MM/YYYY HH:mm:ss")}</p>
            </div>,
        },
        {
            name: '',
            columnClassName: 'multiple-wins-popup-info-state',
            rowClassName: 'multiple-wins-popup-info-state',
            row: item => t(item.status),
        }
    ];
}

export function goldenRaceRacingSelectionColumnConfig() {
    return [
        {
            name: () => t('Match Name'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.event.playlistDescription,
        },
        {
            name: () => t('Market - selection'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.marketFullName,
        },
        {
            name: () => t('Odd'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.oddValue,
        },
        // {
        //     name: () => t('Event result'),
        //     rowClassName: 'multiple-wins-popup-info-row',
        //     row: item => <p className='match_result'>
        //         {this.state.scores && this.state.scores[item.match_id] ? this.state.scores[item.match_id] : "-"}
        //     </p>
        // },
        {
            name: () => t('Start date'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => <div className="match-day">
                <p>{moment(item.event.eventTime).format("DD/MM/YYYY HH:mm:ss")}</p>
            </div>,
        },
        {
            name: '',
            columnClassName: 'multiple-wins-popup-info-state',
            rowClassName: 'multiple-wins-popup-info-state',
            row: item => t(item.status),
        }
    ];
}

export function goldenRaceCasinoTicketInfoColumnConfig() {
    return [
        {
            name: () => t('Game Name'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.event.gameName,
        },
        {
            name: () => t('Market - selection'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.marketFullName,
        },
        // {
        //     name: () =>
        //         t('Draw date'),
        //         rowClassName: 'multiple-wins-popup-info-row',
        //     row: (item) => {
        //         const drawDateExists = !item.DrawDate.startsWith('1970') && !item.DrawDate.startsWith('0001');
        //         return drawDateExists ? moment(item.DrawDate).format(Config.main.dateTimeFormat) : '-';
        //     } 
        // },
        {
            name: () => t('Numbers'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => {
                const numbers = item.betParam.split(',');
                return numbers && <CasinoNumbers numbers={numbers} />
            },
        },
        {
            name: '',
            columnClassName: 'multiple-wins-popup-info-state',
            rowClassName: 'multiple-wins-popup-info-state',
            row: item => t(item.status),
        }
    ];
}